import React from "react";
import { getBezierPath } from "react-flow-renderer";
import { useNodeActions } from "../context/NodeActionsContext";

const BUTTON_R = 10;

const ButtonEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  animated,
  selected,
}) => {
  const { onDeleteEdge } = useNodeActions();

  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Centro geométrico entre source y target — posición del botón de borrado
  const cx = (sourceX + targetX) / 2;
  const cy = (sourceY + targetY) / 2;

  const pathStyle = {
    ...style,
    strokeWidth: style?.strokeWidth ?? 3,
  };

  return (
    <>
      <path
        id={id}
        style={pathStyle}
        className={`react-flow__edge-path${animated ? " animated" : ""}`}
        d={edgePath}
        markerEnd={markerEnd}
      />

      {/* Hitbox invisible más amplio para facilitar la interacción */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={20}
        style={{ cursor: "pointer" }}
      />

      {/* Botón circular de borrado en el centro de la arista */}
      <g
        className="edge-delete-btn"
        onClick={(e) => {
          e.stopPropagation();
          onDeleteEdge(id);
        }}
        style={{ cursor: "pointer" }}
      >
        {/* Sombra suave */}
        <circle
          cx={cx}
          cy={cy}
          r={BUTTON_R + 1}
          fill="rgba(0,0,0,0.12)"
          style={{ pointerEvents: "none" }}
        />
        {/* Círculo de fondo */}
        <circle
          cx={cx}
          cy={cy}
          r={BUTTON_R}
          fill="white"
          stroke={selected ? "#e53935" : "#bbb"}
          strokeWidth={1.5}
        />
        {/* × */}
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#e53935"
          fontSize={14}
          fontWeight={700}
          style={{ userSelect: "none", pointerEvents: "none", fontFamily: "sans-serif" }}
        >
          ×
        </text>
      </g>
    </>
  );
};

export default ButtonEdge;
